(() => {
  const normalizeUsPhone = (value) => {
    const raw = value.trim();
    const digits = raw.replace(/\D/g, "");

    if (raw.startsWith("+") && digits.length >= 10 && digits.length <= 15) {
      return `+${digits}`;
    }

    if (digits.length === 10) {
      return `+1${digits}`;
    }

    if (digits.length === 11 && digits.startsWith("1")) {
      return `+${digits}`;
    }

    return "";
  };

  document.querySelectorAll("[data-summer-bash-registration]").forEach((form) => {
    if (form.dataset.registrationReady === "true") return;
    form.dataset.registrationReady = "true";

    const reminderChoice = form.elements.sms_reminder;
    const phonePanel = form.querySelector(".summer-bash__phone-panel");
    const phoneInput = form.elements.phone_number;
    const submitButton = form.querySelector(".summer-bash__submit");
    const status = form.querySelector(".summer-bash__form-status");
    const backupForm = document.getElementById(form.dataset.backupFormId);

    const syncPhoneField = () => {
      const wantsReminder = reminderChoice.checked;
      phonePanel.hidden = !wantsReminder;
      phoneInput.required = wantsReminder;

      if (!wantsReminder) {
        phoneInput.value = "";
      }
    };

    reminderChoice.addEventListener("change", syncPhoneField);
    syncPhoneField();

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      if (form.elements.website.value) {
        status.textContent = "You’re registered. We’ll see you at Sony Summer Bash.";
        return;
      }

      const companyId = form.dataset.companyId;
      const listId = form.dataset.listId;
      const wantsReminder = reminderChoice.checked;
      const normalizedPhone = wantsReminder ? normalizeUsPhone(phoneInput.value) : "";
      const firstName = form.elements.first_name.value.trim();
      const email = form.elements.email.value.trim();

      if (wantsReminder && !normalizedPhone) {
        status.textContent = "Enter a valid U.S. mobile number, including area code.";
        phoneInput.focus();
        return;
      }

      const profileAttributes = {
        first_name: firstName,
        email,
        properties: {
          "Sony Summer Bash 2026 Registration": true,
          "Event Date": "2026-08-29",
          "Registration Source": "Pictureline event landing page"
        },
        subscriptions: {
          email: {
            marketing: {
              consent: "SUBSCRIBED"
            }
          }
        }
      };

      if (wantsReminder) {
        profileAttributes.phone_number = normalizedPhone;
        profileAttributes.subscriptions.sms = {
          marketing: {
            consent: "SUBSCRIBED"
          }
        };
      }

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Sony Summer Bash 2026 landing page",
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      submitButton.disabled = true;
      submitButton.textContent = "Registering…";
      status.textContent = "";

      try {
        const klaviyoRequest = fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2026-07-15"
            },
            body: JSON.stringify(payload)
          }
        );

        const backupRequest = backupForm
          ? (() => {
              backupForm.elements["contact[email]"].value = email;
              backupForm.elements["contact[first_name]"].value = firstName;
              backupForm.elements["contact[phone]"].value = normalizedPhone;

              return fetch(backupForm.action, {
                method: "POST",
                body: new FormData(backupForm),
                headers: {
                  accept: "text/html"
                }
              });
            })()
          : Promise.reject(new Error("Shopify backup form is unavailable"));

        const [klaviyoResult, backupResult] = await Promise.allSettled([
          klaviyoRequest,
          backupRequest
        ]);
        const klaviyoSaved =
          klaviyoResult.status === "fulfilled" && klaviyoResult.value.ok;
        const backupSaved =
          backupResult.status === "fulfilled" && backupResult.value.ok;

        if (!klaviyoSaved && !backupSaved) {
          throw new Error("Registration could not be saved");
        }

        if (!klaviyoSaved) console.warn("Sony Summer Bash: Klaviyo save failed");
        if (!backupSaved) console.warn("Sony Summer Bash: Shopify backup save failed");

        form.reset();
        syncPhoneField();
        form.classList.add("is-complete");
        status.textContent = wantsReminder
          ? "You’re registered. We’ll send event details by email and text."
          : "You’re registered. We’ll email you the event details.";
      } catch (error) {
        status.textContent = "We couldn’t complete registration. Please try again in a moment.";
        submitButton.disabled = false;
        submitButton.textContent = "Reserve my spot";
      }
    });
  });
})();
